import axios from '../../axios'

// 新增新增省份分数线
export const addProvinceScoreLine = (data) => {
    return axios({
        url: '/api/data/wish/score',
        method: 'POST',
        data
    })
}

// 获取省份分数线详情
export const getProvinceScoreLineInfo = (data) => {
    return axios({
        url: '/api/data/wish/score/info',
        method: 'GET',
        data
    })
}

// 修改省份分数线信息
export const editProvinceScoreLine = (data) => {
    return axios({
        url: '/api/data/wish/score',
        method: 'PUT',
        data
    })
}

// 删除省份分数线信息
export const deleteProvinceScoreLine = (data) => {
    return axios({
        url: '/api/data/wish/score',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索省份分数线信息列表
export const searchProvinceScoreList = (data) => {
    return axios({
        url: '/api/data/wish/score',
        method: 'GET',
        data
    })
}

// 导入省份分数线信息
export const importProvinceScore = (data) => {
    return axios({
        url: '/api/data/wish/score/import',
        method: 'POST',
        data
    })
}

// 导出省份分数线信息
export const exportProvinceScore = (data) => {
    return axios({
        url: '/api/data/wish/score/export',
        method: 'POST',
        data
    })
}

// 批量更新省份分数线信息
export const updateProvinceScore = (data) => {
    return axios({
        url: '/api/data/wish/score/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除省份分数线信息
export const quryDelProvinceScore = (data) => {
    return axios({
        url: '/api/data/wish/score/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/provincescoreline.js